import { calculateColumnLetters } from '@pages/Filing/ConversionTool/MappingSteps/CTStepOne/components/ConversionSettingsForm/helpers/calculateColumnLetters';
import {
  STATIC,
  FORMULA,
  COLUMN,
  NOT_PROVIDED,
} from '@pages/Filing/ConversionTool/MappingSteps/CTStepOne/constants';

export const conversionToolSettingsData = {
  count: 4,
  next: null,
  previous: null,
  results: [
    {
      id: '123',
      name: 'test vat shape',
      vat_number: '123',
      filing_type: '456',
      header_start: 1,
      row_start: 2,
      column_map: {
        ccy: {
          type: 'column',
          value: '5',
        },
        net: {
          type: 'column',
          value: '6',
        },
        vat: {
          type: 'column',
          value: '7',
        },
        gross: {
          type: 'column',
          value: '8',
        },
        invoice_date: {
          type: 'column',
          value: '1',
        },
        partner_name: {
          type: 'column',
          value: '2',
        },
        ec_vat_number: {
          type: 'column',
          value: '4',
        },
        invoice_number: {
          type: 'column',
          value: '0',
        },
        partner_country: {
          type: 'column',
          value: '3',
        },
        client_transaction_type: {
          type: 'column',
          value: '9',
        },
      },
    },
    {
      id: '433',
      name: 'test new tut layout',
      vat_number: '76',
      filing_type: '456',
      header_start: 1,
      row_start: 2,
      column_map: {
        ccy: {
          type: 'column',
          value: '5',
        },
        net: {
          type: 'column',
          value: '6',
        },
        vat: {
          type: 'column',
          value: '7',
        },
        gross: {
          type: 'column',
          value: '8',
        },
        invoice_date: {
          type: 'column',
          value: '1',
        },
        partner_name: {
          type: 'column',
          value: '2',
        },
        ec_vat_number: {
          type: 'column',
          value: '4',
        },
        invoice_number: {
          type: 'column',
          value: '0',
        },
        partner_country: {
          type: 'column',
          value: '3',
        },
        client_transaction_type: {
          type: 'column',
          value: '9',
        },
      },
    },
    {
      id: '9876',
      name: 'CTMappings',
      vat_number: '456',
      filing_type: '23',
      header_start: 1,
      row_start: 2,
      column_map: {
        ccy: {
          type: 'column',
          value: '5',
        },
        net: {
          type: 'column',
          value: '6',
        },
        vat: {
          type: 'column',
          value: '7',
        },
        gross: {
          type: 'column',
          value: '8',
        },
        invoice_date: {
          type: 'column',
          value: '1',
        },
        partner_name: {
          type: 'column',
          value: '2',
        },
        ec_vat_number: {
          type: 'column',
          value: '4',
        },
        invoice_number: {
          type: 'column',
          value: '0',
        },
        partner_country: {
          type: 'column',
          value: '3',
        },
        client_transaction_type: {
          type: 'column',
          value: '9',
        },
      },
    },
  ],
};

export const filingTypes = {
  results: [
    {
      periodDetail: {
        filingType: {
          id: '123',
          nameShort: 'VAT',
          nameLong: 'VAT Return',
          offvsuitePaymentDetailsReq: true,
        },
      },
    },
  ],
};

export const mappingsData = [
  {
    values: ['please workqqqq', 'VAT Return', null, null],
  },
  {
    values: ['Murali-no-headers', 'VAT Return', null, null],
  },
  {
    values: ['vsuite maps 111', 'VAT Return', null, null],
  },
  {
    values: ['vsuite maps 12345', 'VAT Return', null, null],
  },
  {
    values: ['vsuite009', 'VAT Return', null, null],
  },
];

export const conversionToolColumnsWithOptions = [
  {
    id: 'invoice_number',
    type: 'text',
    displayName: 'Invoice Number',
    description: 'Invoice number or transaction number.',
    placeholder: 'Placeholder',
    options: [
      { id: COLUMN, displayName: 'In my sheet' },
      {
        id: FORMULA,
        displayName: 'Custom Value',
        options: [
          { id: 'option_two', displayName: 'Option two' },
          { id: 'option_one', displayName: 'Option one' },
        ],
      },
    ],
    required: true,
  },
  {
    id: 'invoice_date',
    type: 'date',
    displayName: 'Invoice Date',
    description: 'Invoice date or transaction date.',
    placeholder: 'Placeholder',
    options: [
      { id: COLUMN, displayName: 'In my sheet' },
      {
        id: FORMULA,
        displayName: 'Custom Value',
      },
      {
        id: NOT_PROVIDED,
        displayName: 'Not provided',
      },
    ],
    required: false,
  },
  {
    id: 'partner_name',
    type: 'text',
    displayName: 'Partner Name',
    description: 'Name of the vendor or customer.',
    placeholder: 'Placeholder',
    required: true,
  },
  {
    id: 'partner_country',
    type: 'text',
    displayName: 'Partner Country',
    description: 'Country of the vendor or customer.',
    placeholder: 'Placeholder',
    options: [
      { id: COLUMN, displayName: 'In my sheet' },
      { id: 'option_one', displayName: 'Option one' },
    ],
    required: true,
  },
  {
    id: 'ec_vat_number',
    type: 'text',
    displayName: 'EC Vat Number',
    description: 'VAT number of the supplier or customer.',
    placeholder: 'Placeholder',
    options: [
      { id: COLUMN, displayName: 'In my sheet' },
      { id: 'option_one', displayName: 'Option one' },
    ],
    required: true,
  },
  {
    id: 'currency',
    type: 'text',
    displayName: 'Currency',
    description: 'ISO currency code of the transaction as per the original invoice.',
    placeholder: 'Placeholder',
    options: [
      { id: COLUMN, displayName: 'In my sheet' },
      { id: 'option_one', displayName: 'Option one' },
    ],
    required: true,
  },
  {
    id: 'net',
    type: 'money',
    displayName: 'Net',
    description: 'Net amount per transaction.',
    placeholder: 'Placeholder',
    options: [
      { id: COLUMN, displayName: 'In my sheet' },
      { id: STATIC, displayName: 'Calculated', requiredColumns: ['vat', 'gross'] },
      { id: NOT_PROVIDED, displayName: 'Not provided' },
    ],
    required: false,
  },
  {
    id: 'vat',
    type: 'money',
    displayName: 'VAT',
    description: 'VAT amount per transaction.',
    placeholder: 'Placeholder',
    options: [
      { id: COLUMN, displayName: 'In my sheet' },
      { id: 'option_one', displayName: 'Option one' },
      { id: NOT_PROVIDED, displayName: 'Not provided' },
    ],
    required: false,
  },
  {
    id: 'gross',
    type: 'money',
    displayName: 'Gross',
    description: 'Gross amount per transaction.',
    placeholder: 'Placeholder',
    options: [
      { id: COLUMN, displayName: 'In my sheet' },
      {
        requiredColumns: ['vat', 'net'],
        id: STATIC,
        displayName: 'Calculated',
      },
      { id: NOT_PROVIDED, displayName: 'Not provided' },
    ],
    required: false,
  },
  {
    id: 'client_transaction_type',
    type: 'text',
    displayName: 'Client Transaction Type',
    description: 'Either a tax code, or transaction type per the ERP system.',
    placeholder: 'Placeholder',
    options: [
      { id: COLUMN, displayName: 'In my sheet' },
      { id: 'option_one', displayName: 'Option one' },
      { id: NOT_PROVIDED, displayName: 'Not provided' },
    ],
    required: false,
  },
];

export const columnData = [
  {
    id: 'invoice_number',
    display: 'Invoice Number',
    description: 'Invoice number or transaction number.',
    type: 'text',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
    ],
  },
  {
    id: 'invoice_date',
    display: 'Invoice Date',
    description: 'Invoice date or transaction date.',
    type: 'date',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
    ],
  },
  {
    id: 'partner_name',
    display: 'Partner Name',
    description: 'Name of the vendor or customer.',
    type: 'text',
    required: false,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
      {
        display: 'Not provided',
        optionType: 'not_provided',
      },
    ],
  },
  {
    id: 'partner_country',
    display: 'Partner Country',
    description: 'Country of the vendor or customer.',
    type: 'text',
    required: false,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
      {
        display: 'Custom value',
        optionType: 'static',
        options: [
          {
            id: 'TM',
            displayValue: 'Turkmenistan',
          },
          {
            id: 'MG',
            displayValue: 'Madagascar',
          },
          {
            id: 'MH',
            displayValue: 'Marshall Islands',
          },
          {
            id: 'MK',
            displayValue: 'Macedonia',
          },
          {
            id: 'ML',
            displayValue: 'Mali',
          },
          {
            id: 'IM',
            displayValue: 'Isle of Man',
          },
          {
            id: 'MQ',
            displayValue: 'Martinique',
          },
          {
            id: 'MR',
            displayValue: 'Mauritania',
          },
          {
            id: 'MT',
            displayValue: 'Malta',
          },
          {
            id: 'TR',
            displayValue: 'Turkey',
          },
          {
            id: 'VC',
            displayValue: 'Saint Vincent and the Grenadines',
          },
          {
            id: 'VG',
            displayValue: 'British Virgin Islands',
          },
          {
            id: 'IO',
            displayValue: 'British Indian Ocean Territory',
          },
          {
            id: 'MU',
            displayValue: 'Mauritius',
          },
          {
            id: 'JE',
            displayValue: 'Jersey',
          },
          {
            id: 'JP',
            displayValue: 'Japan',
          },
          {
            id: 'KE',
            displayValue: 'Kenya',
          },
          {
            id: 'MV',
            displayValue: 'Maldives',
          },
          {
            id: 'KI',
            displayValue: 'Kiribati',
          },
          {
            id: 'KM',
            displayValue: 'Comoros',
          },
          {
            id: 'MY',
            displayValue: 'Malaysia',
          },
          {
            id: 'KN',
            displayValue: 'Saint Kitts and Nevis',
          },
          {
            id: 'NC',
            displayValue: 'New Caledonia',
          },
          {
            id: 'KP',
            displayValue: 'North Korea',
          },
          {
            id: 'NO',
            displayValue: 'Norway',
          },
          {
            id: 'KR',
            displayValue: 'South Korea',
          },
          {
            id: 'BH',
            displayValue: 'Bahrain',
          },
          {
            id: 'BQ',
            displayValue: 'British Antarctic Territory',
          },
          {
            id: 'BR',
            displayValue: 'Brazil',
          },
          {
            id: 'BS',
            displayValue: 'Bahamas',
          },
          {
            id: 'NS',
            displayValue: 'Canada (Nova Scotia)',
          },
          {
            id: 'LA',
            displayValue: 'Laos',
          },
          {
            id: 'ON',
            displayValue: 'Canada (Ontario)',
          },
          {
            id: 'LC',
            displayValue: 'Saint Lucia',
          },
          {
            id: 'CC',
            displayValue: 'Cocos [Keeling] Islands',
          },
          {
            id: 'LI',
            displayValue: 'Liechtenstein',
          },
          {
            id: 'CG',
            displayValue: 'Congo - Brazzaville',
          },
          {
            id: 'CO',
            displayValue: 'Colombia',
          },
          {
            id: 'CX',
            displayValue: 'Christmas Island',
          },
          {
            id: 'SK',
            displayValue: 'Slovakia',
          },
          {
            id: 'LK',
            displayValue: 'Sri Lanka',
          },
          {
            id: 'LV',
            displayValue: 'Latvia',
          },
          {
            id: 'EE',
            displayValue: 'Estonia',
          },
          {
            id: 'SL',
            displayValue: 'Sierra Leone',
          },
          {
            id: 'EG',
            displayValue: 'Egypt',
          },
          {
            id: 'EH',
            displayValue: 'Western Sahara',
          },
          {
            id: 'SM',
            displayValue: 'San Marino',
          },
          {
            id: 'ER',
            displayValue: 'Eritrea',
          },
          {
            id: 'ES',
            displayValue: 'Spain',
          },
          {
            id: 'SN',
            displayValue: 'Senegal',
          },
          {
            id: 'GQ',
            displayValue: 'Equatorial Guinea',
          },
          {
            id: 'GS',
            displayValue: 'South Georgia and the South Sandwich Islands',
          },
          {
            id: 'SO',
            displayValue: 'Somalia',
          },
          {
            id: 'MD',
            displayValue: 'Moldova',
          },
          {
            id: 'MF',
            displayValue: 'Saint Martin',
          },
          {
            id: 'GE',
            displayValue: 'Georgia',
          },
          {
            id: 'GF',
            displayValue: 'French Guiana',
          },
          {
            id: 'GH',
            displayValue: 'Ghana',
          },
          {
            id: 'GL',
            displayValue: 'Greenland',
          },
          {
            id: 'GP',
            displayValue: 'Guadeloupe',
          },
          {
            id: 'GR',
            displayValue: 'Greece',
          },
          {
            id: 'GY',
            displayValue: 'Guyana',
          },
          {
            id: 'HK',
            displayValue: 'Hong Kong SAR China',
          },
          {
            id: 'IE',
            displayValue: 'Ireland',
          },
          {
            id: 'KH',
            displayValue: 'Cambodia',
          },
          {
            id: 'MC',
            displayValue: 'Monaco',
          },
          {
            id: 'ME',
            displayValue: 'Montenegro',
          },
          {
            id: 'MW',
            displayValue: 'Malawi',
          },
          {
            id: 'MX',
            displayValue: 'Mexico',
          },
          {
            id: 'BG',
            displayValue: 'Bulgaria',
          },
          {
            id: 'BN',
            displayValue: 'Brunei',
          },
          {
            id: 'CD',
            displayValue: 'Congo - Kinshasa',
          },
          {
            id: 'ET',
            displayValue: 'Ethiopia',
          },
          {
            id: 'FJ',
            displayValue: 'Fiji',
          },
          {
            id: 'FK',
            displayValue: 'Falkland Islands',
          },
          {
            id: 'FM',
            displayValue: 'Micronesia',
          },
          {
            id: 'FO',
            displayValue: 'Faroe Islands',
          },
          {
            id: 'FR',
            displayValue: 'France',
          },
          {
            id: 'GA',
            displayValue: 'Gabon',
          },
          {
            id: 'GB',
            displayValue: 'United Kingdom',
          },
          {
            id: 'GC',
            displayValue: 'Channel Islands',
          },
          {
            id: 'GD',
            displayValue: 'Grenada',
          },
          {
            id: 'TO',
            displayValue: 'Tonga',
          },
          {
            id: 'YD',
            displayValue: "People's Democratic Republic of Yemen",
          },
          {
            id: 'PU',
            displayValue: 'U.S. Miscellaneous Pacific Islands',
          },
          {
            id: 'ZZ',
            displayValue: 'Unknown or Invalid Region',
          },
          {
            id: 'WK',
            displayValue: 'Wake Island',
          },
          {
            id: 'AD',
            displayValue: 'Andorra',
          },
          {
            id: 'AE',
            displayValue: 'United Arab Emirates',
          },
          {
            id: 'AF',
            displayValue: 'Afghanistan',
          },
          {
            id: 'AG',
            displayValue: 'Antigua and Barbuda',
          },
          {
            id: 'AI',
            displayValue: 'Anguilla',
          },
          {
            id: 'AL',
            displayValue: 'Albania',
          },
          {
            id: 'AM',
            displayValue: 'Armenia',
          },
          {
            id: 'AO',
            displayValue: 'Angola',
          },
          {
            id: 'AR',
            displayValue: 'Argentina',
          },
          {
            id: 'AS',
            displayValue: 'American Samoa',
          },
          {
            id: 'AT',
            displayValue: 'Austria',
          },
          {
            id: 'AU',
            displayValue: 'Australia',
          },
          {
            id: 'AW',
            displayValue: 'Aruba',
          },
          {
            id: 'AX',
            displayValue: 'Åland Islands',
          },
          {
            id: 'AZ',
            displayValue: 'Azerbaijan',
          },
          {
            id: 'BA',
            displayValue: 'Bosnia and Herzegovina',
          },
          {
            id: 'BB',
            displayValue: 'Barbados',
          },
          {
            id: 'BD',
            displayValue: 'Bangladesh',
          },
          {
            id: 'TD',
            displayValue: 'Chad',
          },
          {
            id: 'CF',
            displayValue: 'Central African Republic',
          },
          {
            id: 'BE',
            displayValue: 'Belgium',
          },
          {
            id: 'BF',
            displayValue: 'Burkina Faso',
          },
          {
            id: 'BI',
            displayValue: 'Burundi',
          },
          {
            id: 'BJ',
            displayValue: 'Benin',
          },
          {
            id: 'BL',
            displayValue: 'Saint Barthélemy',
          },
          {
            id: 'CH',
            displayValue: 'Switzerland',
          },
          {
            id: 'CI',
            displayValue: 'Côte d’Ivoire',
          },
          {
            id: 'CK',
            displayValue: 'Cook Islands',
          },
          {
            id: 'BM',
            displayValue: 'Bermuda',
          },
          {
            id: 'BO',
            displayValue: 'Bolivia',
          },
          {
            id: 'CL',
            displayValue: 'Chile',
          },
          {
            id: 'CM',
            displayValue: 'Cameroon',
          },
          {
            id: 'CN',
            displayValue: 'China',
          },
          {
            id: 'CR',
            displayValue: 'Costa Rica',
          },
          {
            id: 'BT',
            displayValue: 'Bhutan',
          },
          {
            id: 'BV',
            displayValue: 'Bouvet Island',
          },
          {
            id: 'BW',
            displayValue: 'Botswana',
          },
          {
            id: 'BY',
            displayValue: 'Belarus',
          },
          {
            id: 'BZ',
            displayValue: 'Belize',
          },
          {
            id: 'CA',
            displayValue: 'Canada',
          },
          {
            id: 'AB',
            displayValue: 'Canada (Alberta)',
          },
          {
            id: 'BC',
            displayValue: 'Canada (British Columbia)',
          },
          {
            id: 'MB',
            displayValue: 'Canada (Manitoba)',
          },
          {
            id: 'NB',
            displayValue: 'Canada (New Brunswick)',
          },
          {
            id: 'QC',
            displayValue: 'Canada (Quebec)',
          },
          {
            id: 'CS',
            displayValue: 'Canada (Saskatchewan)',
          },
          {
            id: 'CU',
            displayValue: 'Cuba',
          },
          {
            id: 'CV',
            displayValue: 'Cape Verde',
          },
          {
            id: 'CY',
            displayValue: 'Cyprus',
          },
          {
            id: 'CZ',
            displayValue: 'Czech Republic',
          },
          {
            id: 'DE',
            displayValue: 'Germany',
          },
          {
            id: 'DJ',
            displayValue: 'Djibouti',
          },
          {
            id: 'DK',
            displayValue: 'Denmark',
          },
          {
            id: 'DM',
            displayValue: 'Dominica',
          },
          {
            id: 'DO',
            displayValue: 'Dominican Republic',
          },
          {
            id: 'DZ',
            displayValue: 'Algeria',
          },
          {
            id: 'EC',
            displayValue: 'Ecuador',
          },
          {
            id: 'FI',
            displayValue: 'Finland',
          },
          {
            id: 'GI',
            displayValue: 'Gibraltar',
          },
          {
            id: 'GM',
            displayValue: 'Gambia',
          },
          {
            id: 'GN',
            displayValue: 'Guinea',
          },
          {
            id: 'NT',
            displayValue: 'Canada (Northwest Territories)',
          },
          {
            id: 'MM',
            displayValue: 'Myanmar [Burma]',
          },
          {
            id: 'MN',
            displayValue: 'Mongolia',
          },
          {
            id: 'MO',
            displayValue: 'Macau SAR China',
          },
          {
            id: 'MP',
            displayValue: 'Northern Mariana Islands',
          },
          {
            id: 'MS',
            displayValue: 'Montserrat',
          },
          {
            id: 'MZ',
            displayValue: 'Mozambique',
          },
          {
            id: 'NA',
            displayValue: 'Namibia',
          },
          {
            id: 'NE',
            displayValue: 'Niger',
          },
          {
            id: 'NF',
            displayValue: 'Norfolk Island',
          },
          {
            id: 'GT',
            displayValue: 'Guatemala',
          },
          {
            id: 'GU',
            displayValue: 'Guam',
          },
          {
            id: 'GW',
            displayValue: 'Guinea-Bissau',
          },
          {
            id: 'HM',
            displayValue: 'Heard Island and McDonald Islands',
          },
          {
            id: 'HN',
            displayValue: 'Honduras',
          },
          {
            id: 'HR',
            displayValue: 'Croatia',
          },
          {
            id: 'HT',
            displayValue: 'Haiti',
          },
          {
            id: 'HU',
            displayValue: 'Hungary',
          },
          {
            id: 'ID',
            displayValue: 'Indonesia',
          },
          {
            id: 'IL',
            displayValue: 'Israel',
          },
          {
            id: 'IN',
            displayValue: 'India',
          },
          {
            id: 'IQ',
            displayValue: 'Iraq',
          },
          {
            id: 'IR',
            displayValue: 'Iran',
          },
          {
            id: 'IS',
            displayValue: 'Iceland',
          },
          {
            id: 'IT',
            displayValue: 'Italy',
          },
          {
            id: 'JM',
            displayValue: 'Jamaica',
          },
          {
            id: 'JO',
            displayValue: 'Jordan',
          },
          {
            id: 'KG',
            displayValue: 'Kyrgyzstan',
          },
          {
            id: 'KW',
            displayValue: 'Kuwait',
          },
          {
            id: 'KY',
            displayValue: 'Cayman Islands',
          },
          {
            id: 'KZ',
            displayValue: 'Kazakhstan',
          },
          {
            id: 'LB',
            displayValue: 'Lebanon',
          },
          {
            id: 'LR',
            displayValue: 'Liberia',
          },
          {
            id: 'LS',
            displayValue: 'Lesotho',
          },
          {
            id: 'LT',
            displayValue: 'Lithuania',
          },
          {
            id: 'LU',
            displayValue: 'Luxembourg',
          },
          {
            id: 'LY',
            displayValue: 'Libya',
          },
          {
            id: 'MA',
            displayValue: 'Morocco',
          },
          {
            id: 'NG',
            displayValue: 'Nigeria',
          },
          {
            id: 'NI',
            displayValue: 'Nicaragua',
          },
          {
            id: 'NL',
            displayValue: 'Netherlands',
          },
          {
            id: 'NP',
            displayValue: 'Nepal',
          },
          {
            id: 'NR',
            displayValue: 'Nauru',
          },
          {
            id: 'NU',
            displayValue: 'Niue',
          },
          {
            id: 'TG',
            displayValue: 'Togo',
          },
          {
            id: 'VA',
            displayValue: 'Vatican City',
          },
          {
            id: 'YT',
            displayValue: 'Mayotte',
          },
          {
            id: 'SJ',
            displayValue: 'Svalbard and Jan Mayen',
          },
          {
            id: 'VE',
            displayValue: 'Venezuela',
          },
          {
            id: 'VI',
            displayValue: 'U.S. Virgin Islands',
          },
          {
            id: 'ZA',
            displayValue: 'South Africa',
          },
          {
            id: 'TH',
            displayValue: 'Thailand',
          },
          {
            id: 'TW',
            displayValue: 'Taiwan',
          },
          {
            id: 'SA',
            displayValue: 'Saudi Arabia',
          },
          {
            id: 'VN',
            displayValue: 'Vietnam',
          },
          {
            id: 'TJ',
            displayValue: 'Tajikistan',
          },
          {
            id: 'PH',
            displayValue: 'Philippines',
          },
          {
            id: 'VU',
            displayValue: 'Vanuatu',
          },
          {
            id: 'TZ',
            displayValue: 'Tanzania',
          },
          {
            id: 'ZM',
            displayValue: 'Zambia',
          },
          {
            id: 'ZW',
            displayValue: 'Zimbabwe',
          },
          {
            id: 'WF',
            displayValue: 'Wallis and Futuna',
          },
          {
            id: 'WS',
            displayValue: 'Samoa',
          },
          {
            id: 'UA',
            displayValue: 'Ukraine',
          },
          {
            id: 'TK',
            displayValue: 'Tokelau',
          },
          {
            id: 'SR',
            displayValue: 'Suriname',
          },
          {
            id: 'TL',
            displayValue: 'Timor-Leste',
          },
          {
            id: 'PW',
            displayValue: 'Palau',
          },
          {
            id: 'TN',
            displayValue: 'Tunisia',
          },
          {
            id: 'PK',
            displayValue: 'Pakistan',
          },
          {
            id: 'UG',
            displayValue: 'Uganda',
          },
          {
            id: 'PY',
            displayValue: 'Paraguay',
          },
          {
            id: 'ST',
            displayValue: 'São Tomé and Príncipe',
          },
          {
            id: 'QA',
            displayValue: 'Qatar',
          },
          {
            id: 'PL',
            displayValue: 'Poland',
          },
          {
            id: 'SB',
            displayValue: 'Solomon Islands',
          },
          {
            id: 'UM',
            displayValue: 'U.S. Minor Outlying Islands',
          },
          {
            id: 'PM',
            displayValue: 'Saint Pierre and Miquelon',
          },
          {
            id: 'TT',
            displayValue: 'Trinidad and Tobago',
          },
          {
            id: 'SV',
            displayValue: 'El Salvador',
          },
          {
            id: 'US',
            displayValue: 'United States',
          },
          {
            id: 'RE',
            displayValue: 'Réunion',
          },
          {
            id: 'SY',
            displayValue: 'Syria',
          },
          {
            id: 'PN',
            displayValue: 'Pitcairn Islands',
          },
          {
            id: 'PR',
            displayValue: 'Puerto Rico',
          },
          {
            id: 'SC',
            displayValue: 'Seychelles',
          },
          {
            id: 'PS',
            displayValue: 'Palestinian Territories',
          },
          {
            id: 'SD',
            displayValue: 'Sudan',
          },
          {
            id: 'RO',
            displayValue: 'Romania',
          },
          {
            id: 'SE',
            displayValue: 'Sweden',
          },
          {
            id: 'SG',
            displayValue: 'Singapore',
          },
          {
            id: 'SH',
            displayValue: 'Saint Helena',
          },
          {
            id: 'SZ',
            displayValue: 'Swaziland',
          },
          {
            id: 'YE',
            displayValue: 'Yemen',
          },
          {
            id: 'RS',
            displayValue: 'Serbia',
          },
          {
            id: 'RU',
            displayValue: 'Russia',
          },
          {
            id: 'RW',
            displayValue: 'Rwanda',
          },
          {
            id: 'NZ',
            displayValue: 'New Zealand',
          },
          {
            id: 'OM',
            displayValue: 'Oman',
          },
          {
            id: 'PA',
            displayValue: 'Panama',
          },
          {
            id: 'UY',
            displayValue: 'Uruguay',
          },
          {
            id: 'UZ',
            displayValue: 'Uzbekistan',
          },
          {
            id: 'PE',
            displayValue: 'Peru',
          },
          {
            id: 'TV',
            displayValue: 'Tuvalu',
          },
          {
            id: 'SI',
            displayValue: 'Slovenia',
          },
          {
            id: 'PF',
            displayValue: 'French Polynesia',
          },
          {
            id: 'TC',
            displayValue: 'Turks and Caicos Islands',
          },
          {
            id: 'TF',
            displayValue: 'French Southern Territories',
          },
          {
            id: 'PG',
            displayValue: 'Papua New Guinea',
          },
          {
            id: 'PT',
            displayValue: 'Portugal',
          },
          {
            id: 'AQ',
            displayValue: 'Antarctica',
          },
          {
            id: 'CT',
            displayValue: 'Canton and Enderbury Islands',
          },
          {
            id: 'NQ',
            displayValue: 'Dronning Maud Land',
          },
          {
            id: 'FQ',
            displayValue: 'French Southern and Antarctic Territories',
          },
          {
            id: 'GG',
            displayValue: 'Guernsey',
          },
          {
            id: 'JT',
            displayValue: 'Johnston Island',
          },
          {
            id: 'FX',
            displayValue: 'Metropolitan France',
          },
          {
            id: 'MI',
            displayValue: 'Midway Islands',
          },
          {
            id: 'AN',
            displayValue: 'Netherlands Antilles',
          },
          {
            id: 'PC',
            displayValue: 'Pacific Islands Trust Territory',
          },
        ],
      },
      {
        display: 'Set it to the filing country',
        optionType: 'formula',
        requires: [],
        formula: '= country_code',
      },
      {
        display: 'Not provided',
        optionType: 'not_provided',
      },
    ],
  },
  {
    id: 'ec_vat_number',
    display: 'EC Vat Number',
    description: 'VAT number of the supplier or customer.',
    type: 'text',
    required: false,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
      {
        display: 'Not provided',
        optionType: 'not_provided',
      },
    ],
  },
  {
    id: 'ccy',
    display: 'Currency',
    description: 'ISO currency code of the transaction as per the original invoice.',
    type: 'text',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
      {
        display: 'Custom value',
        optionType: 'static',
        options: [
          {
            id: 'QAR',
            displayValue: 'Qatari Rial',
          },
          {
            id: 'RUB',
            displayValue: 'Russian Ruble',
          },
          {
            id: 'RWF',
            displayValue: 'Rwanda Franc',
          },
          {
            id: 'SAR',
            displayValue: 'Saudi Riyal',
          },
          {
            id: 'SBD',
            displayValue: 'Solomon Islands Dollar',
          },
          {
            id: 'SCR',
            displayValue: 'Seychelles Rupee',
          },
          {
            id: 'SEK',
            displayValue: 'Swedish Krona',
          },
          {
            id: 'SGD',
            displayValue: 'Singapore Dollar',
          },
          {
            id: 'EUR',
            displayValue: 'Euro',
          },
          {
            id: 'XCD',
            displayValue: 'East Caribbean Dollar',
          },
          {
            id: 'AUD',
            displayValue: 'Australian Dollar',
          },
          {
            id: 'BDT',
            displayValue: 'Taka',
          },
          {
            id: 'BIF',
            displayValue: 'Burundi Franc',
          },
          {
            id: 'NOK',
            displayValue: 'Norwegian Krone',
          },
          {
            id: 'XAF',
            displayValue: 'CFA Franc BEAC',
          },
          {
            id: 'CUP',
            displayValue: 'Cuban Peso',
          },
          {
            id: 'AFN',
            displayValue: 'Afghani',
          },
          {
            id: 'AMD',
            displayValue: 'Armenian Dram',
          },
          {
            id: 'AOA',
            displayValue: 'Kwanza',
          },
          {
            id: 'ARS',
            displayValue: 'Argentine Peso',
          },
          {
            id: 'USD',
            displayValue: 'US Dollar',
          },
          {
            id: 'AWG',
            displayValue: 'Aruban Florin',
          },
          {
            id: 'AZN',
            displayValue: 'Azerbaijan Manat',
          },
          {
            id: 'BAM',
            displayValue: 'Convertible Mark',
          },
          {
            id: 'BBD',
            displayValue: 'Barbados Dollar',
          },
          {
            id: 'BND',
            displayValue: 'Brunei Dollar',
          },
          {
            id: 'BOB',
            displayValue: 'Boliviano',
          },
          {
            id: 'BRL',
            displayValue: 'Brazilian Real',
          },
          {
            id: 'BSD',
            displayValue: 'Bahamian Dollar',
          },
          {
            id: 'INR',
            displayValue: 'Indian Rupee',
          },
          {
            id: 'BWP',
            displayValue: 'Pula',
          },
          {
            id: 'BZD',
            displayValue: 'Belize Dollar',
          },
          {
            id: 'CAD',
            displayValue: 'Canadian Dollar',
          },
          {
            id: 'CDF',
            displayValue: 'Congolese Franc',
          },
          {
            id: 'CHF',
            displayValue: 'Swiss Franc',
          },
          {
            id: 'NZD',
            displayValue: 'New Zealand Dollar',
          },
          {
            id: 'CLP',
            displayValue: 'Chilean Peso',
          },
          {
            id: 'CNY',
            displayValue: 'Yuan Renminbi',
          },
          {
            id: 'COP',
            displayValue: 'Colombian Peso',
          },
          {
            id: 'CRC',
            displayValue: 'Costa Rican Colon',
          },
          {
            id: 'CVE',
            displayValue: 'Cabo Verde Escudo',
          },
          {
            id: 'ANG',
            displayValue: 'Netherlands Antillean Guilder',
          },
          {
            id: 'CZK',
            displayValue: 'Czech Koruna',
          },
          {
            id: 'FJD',
            displayValue: 'Fiji Dollar',
          },
          {
            id: 'GMD',
            displayValue: 'Dalasi',
          },
          {
            id: 'GNF',
            displayValue: 'Guinean Franc',
          },
          {
            id: 'GTQ',
            displayValue: 'Quetzal',
          },
          {
            id: 'GYD',
            displayValue: 'Guyana Dollar',
          },
          {
            id: 'HKD',
            displayValue: 'Hong Kong Dollar',
          },
          {
            id: 'HNL',
            displayValue: 'Lempira',
          },
          {
            id: 'HTG',
            displayValue: 'Gourde',
          },
          {
            id: 'HUF',
            displayValue: 'Forint',
          },
          {
            id: 'IDR',
            displayValue: 'Rupiah',
          },
          {
            id: 'ILS',
            displayValue: 'New Israeli Sheqel',
          },
          {
            id: 'DJF',
            displayValue: 'Djibouti Franc',
          },
          {
            id: 'DOP',
            displayValue: 'Dominican Peso',
          },
          {
            id: 'DZD',
            displayValue: 'Algerian Dinar',
          },
          {
            id: 'EGP',
            displayValue: 'Egyptian Pound',
          },
          {
            id: 'ISK',
            displayValue: 'Iceland Krona',
          },
          {
            id: 'JMD',
            displayValue: 'Jamaican Dollar',
          },
          {
            id: 'JPY',
            displayValue: 'Yen',
          },
          {
            id: 'FKP',
            displayValue: 'Falkland Islands Pound',
          },
          {
            id: 'GBP',
            displayValue: 'Pound Sterling',
          },
          {
            id: 'GEL',
            displayValue: 'Lari',
          },
          {
            id: 'GHS',
            displayValue: 'Ghana Cedi',
          },
          {
            id: 'IRR',
            displayValue: 'Iranian Rial',
          },
          {
            id: 'KGS',
            displayValue: 'Som',
          },
          {
            id: 'KHR',
            displayValue: 'Riel',
          },
          {
            id: 'KMF',
            displayValue: 'Comorian Franc ',
          },
          {
            id: 'KPW',
            displayValue: 'North Korean Won',
          },
          {
            id: 'KYD',
            displayValue: 'Cayman Islands Dollar',
          },
          {
            id: 'KZT',
            displayValue: 'Tenge',
          },
          {
            id: 'LAK',
            displayValue: 'Lao Kip',
          },
          {
            id: 'LBP',
            displayValue: 'Lebanese Pound',
          },
          {
            id: 'LKR',
            displayValue: 'Sri Lanka Rupee',
          },
          {
            id: 'LSL',
            displayValue: 'Loti',
          },
          {
            id: 'LYD',
            displayValue: 'Libyan Dinar',
          },
          {
            id: 'MDL',
            displayValue: 'Moldovan Leu',
          },
          {
            id: 'MGA',
            displayValue: 'Malagasy Ariary',
          },
          {
            id: 'MKD',
            displayValue: 'Denar',
          },
          {
            id: 'MMK',
            displayValue: 'Kyat',
          },
          {
            id: 'MNT',
            displayValue: 'Tugrik',
          },
          {
            id: 'MRO',
            displayValue: 'Ouguiya',
          },
          {
            id: 'MVR',
            displayValue: 'Rufiyaa',
          },
          {
            id: 'MWK',
            displayValue: 'Malawi Kwacha',
          },
          {
            id: 'MYR',
            displayValue: 'Malaysian Ringgit',
          },
          {
            id: 'MZN',
            displayValue: 'Mozambique Metical',
          },
          {
            id: 'NAD',
            displayValue: 'Namibia Dollar',
          },
          {
            id: 'XPF',
            displayValue: 'CFP Franc',
          },
          {
            id: 'NIO',
            displayValue: 'Cordoba Oro',
          },
          {
            id: 'NPR',
            displayValue: 'Nepalese Rupee',
          },
          {
            id: 'OMR',
            displayValue: 'Rial Omani',
          },
          {
            id: 'PAB',
            displayValue: 'Balboa',
          },
          {
            id: 'PGK',
            displayValue: 'Kina',
          },
          {
            id: 'KRW',
            displayValue: 'Won',
          },
          {
            id: 'PHP',
            displayValue: 'Philippine Piso',
          },
          {
            id: 'PKR',
            displayValue: 'Pakistan Rupee',
          },
          {
            id: 'PLN',
            displayValue: 'Zloty',
          },
          {
            id: 'PEN',
            displayValue: 'Sol',
          },
          {
            id: 'SOS',
            displayValue: 'Somali Shilling',
          },
          {
            id: 'SDG',
            displayValue: 'Sudanese Pound',
          },
          {
            id: 'RSD',
            displayValue: 'Serbian Dinar',
          },
          {
            id: 'ETB',
            displayValue: 'Ethiopian Birr',
          },
          {
            id: 'TWD',
            displayValue: 'New Taiwan Dollar',
          },
          {
            id: 'VEF',
            displayValue: 'Bolivar',
          },
          {
            id: 'SYP',
            displayValue: 'Syrian Pound',
          },
          {
            id: 'SZL',
            displayValue: 'Lilangeni',
          },
          {
            id: 'UAH',
            displayValue: 'Hryvnia',
          },
          {
            id: 'RON',
            displayValue: 'Romanian Leu',
          },
          {
            id: 'VUV',
            displayValue: 'Vatu',
          },
          {
            id: 'ERN',
            displayValue: 'Nakfa',
          },
          {
            id: 'MOP',
            displayValue: 'Pataca',
          },
          {
            id: 'YER',
            displayValue: 'Yemeni Rial',
          },
          {
            id: 'TZS',
            displayValue: 'Tanzanian Shilling',
          },
          {
            id: 'SSP',
            displayValue: 'South Sudanese Pound',
          },
          {
            id: 'TOP',
            displayValue: "Pa'anga",
          },
          {
            id: 'PYG',
            displayValue: 'Guarani',
          },
          {
            id: 'GIP',
            displayValue: 'Gibraltar Pound',
          },
          {
            id: 'NGN',
            displayValue: 'Naira',
          },
          {
            id: 'UZS',
            displayValue: 'Uzbekistan Sum',
          },
          {
            id: 'UGX',
            displayValue: 'Uganda Shilling',
          },
          {
            id: 'STD',
            displayValue: 'Dobra',
          },
          {
            id: 'THB',
            displayValue: 'Baht',
          },
          {
            id: 'XOF',
            displayValue: 'CFA Franc BCEAO',
          },
          {
            id: 'TMT',
            displayValue: 'Turkmenistan New Manat',
          },
          {
            id: 'DKK',
            displayValue: 'Danish Krone',
          },
          {
            id: 'BYN',
            displayValue: 'Belarusian Ruble',
          },
          {
            id: 'UYU',
            displayValue: 'Peso Uruguayo',
          },
          {
            id: 'LRD',
            displayValue: 'Liberian Dollar',
          },
          {
            id: 'BMD',
            displayValue: 'Bermudian Dollar',
          },
          {
            id: 'TTD',
            displayValue: 'Trinidad and Tobago Dollar',
          },
          {
            id: 'ALL',
            displayValue: 'Lek',
          },
          {
            id: 'ZMW',
            displayValue: 'Zambian Kwacha',
          },
          {
            id: 'TND',
            displayValue: 'Tunisian Dinar',
          },
          {
            id: 'HRK',
            displayValue: 'Kuna',
          },
          {
            id: 'KWD',
            displayValue: 'Kuwaiti Dinar',
          },
          {
            id: 'JOD',
            displayValue: 'Jordanian Dinar',
          },
          {
            id: 'KES',
            displayValue: 'Kenyan Shilling',
          },
          {
            id: 'VND',
            displayValue: 'Dong',
          },
          {
            id: 'AED',
            displayValue: 'UAE Dirham',
          },
          {
            id: 'SHP',
            displayValue: 'Saint Helena Pound',
          },
          {
            id: 'SRD',
            displayValue: 'Surinam Dollar',
          },
          {
            id: 'SLL',
            displayValue: 'Leone',
          },
          {
            id: 'MXN',
            displayValue: 'Mexican Peso',
          },
          {
            id: 'TRY',
            displayValue: 'Turkish Lira',
          },
          {
            id: 'TJS',
            displayValue: 'Somoni',
          },
          {
            id: 'MUR',
            displayValue: 'Mauritius Rupee',
          },
          {
            id: 'BGN',
            displayValue: 'Bulgarian Lev',
          },
          {
            id: 'IQD',
            displayValue: 'Iraqi Dinar',
          },
          {
            id: 'MAD',
            displayValue: 'Moroccan Dirham',
          },
          {
            id: 'ZAR',
            displayValue: 'Rand',
          },
          {
            id: 'BHD',
            displayValue: 'Bahraini Dinar',
          },
        ],
      },
    ],
  },
  {
    id: 'net',
    display: 'Net',
    description: 'Net amount per transaction.',
    type: 'currency',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
      {
        display: 'Calculate it from Gross - VAT',
        optionType: 'formula',
        requires: ['gross', 'vat'],
        formula: '= gross - vat',
      },
    ],
  },
  {
    id: 'vat',
    display: 'VAT',
    description: 'VAT amount per transaction.',
    type: 'currency',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
    ],
  },
  {
    id: 'gross',
    display: 'Gross',
    description: 'Gross amount per transaction.',
    type: 'currency',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
      {
        display: 'Calculate it from Net + VAT',
        optionType: 'formula',
        requires: ['net', 'vat'],
        formula: '= net + vat',
      },
    ],
  },
  {
    id: 'client_transaction_type',
    display: 'Client Transaction Type',
    description: 'Either a tax code, or transaction type per the ERP system.',
    type: 'text',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
    ],
  },
];

export const initialMappingValues = [
  {
    id: 'invoice_number',
    display: 'Invoice Number',
    description: 'Invoice number or transaction number.',
    type: 'text',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
    ],
    value: 'column',
    optionalValue: calculateColumnLetters(11),
    disabled: false,
    selected: false,
    index: 0,
  },
  {
    id: 'invoice_date',
    display: 'Invoice Date',
    description: 'Invoice date or transaction date.',
    type: 'date',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
    ],
    value: 'column',
    optionalValue: calculateColumnLetters(77),
    disabled: false,
    selected: false,
    index: 1,
  },
  {
    id: 'partner_name',
    display: 'Partner Name',
    description: 'Name of the vendor or customer.',
    type: 'text',
    required: false,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
      {
        display: 'Not provided',
        optionType: 'not_provided',
      },
    ],
    value: 'column',
    optionalValue: '',
    disabled: false,
    selected: false,
    index: null,
  },
  {
    id: 'partner_country',
    display: 'Partner Country',
    description: 'Country of the vendor or customer.',
    type: 'text',
    required: false,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
      {
        display: 'Custom value',
        optionType: 'static',
        options: [
          {
            id: 'CN',
            displayValue: 'China',
          },
          {
            id: 'GI',
            displayValue: 'Gibraltar',
          },
          {
            id: 'AB',
            displayValue: 'Canada (Alberta)',
          },
          {
            id: 'BC',
            displayValue: 'Canada (British Columbia)',
          },
          {
            id: 'MB',
            displayValue: 'Canada (Manitoba)',
          },
          {
            id: 'DM',
            displayValue: 'Dominica',
          },
          {
            id: 'CU',
            displayValue: 'Cuba',
          },
          {
            id: 'CO',
            displayValue: 'Colombia',
          },
          {
            id: 'CX',
            displayValue: 'Christmas Island',
          },
          {
            id: 'FR',
            displayValue: 'France',
          },
          {
            id: 'DO',
            displayValue: 'Dominican Republic',
          },
          {
            id: 'FK',
            displayValue: 'Falkland Islands',
          },
          {
            id: 'NS',
            displayValue: 'Canada (Nova Scotia)',
          },
          {
            id: 'DK',
            displayValue: 'Denmark',
          },
          {
            id: 'CY',
            displayValue: 'Cyprus',
          },
          {
            id: 'GH',
            displayValue: 'Ghana',
          },
          {
            id: 'GQ',
            displayValue: 'Equatorial Guinea',
          },
          {
            id: 'EC',
            displayValue: 'Ecuador',
          },
          {
            id: 'NQ',
            displayValue: 'Dronning Maud Land',
          },
          {
            id: 'DJ',
            displayValue: 'Djibouti',
          },
          {
            id: 'EH',
            displayValue: 'Western Sahara',
          },
          {
            id: 'PG',
            displayValue: 'Papua New Guinea',
          },
          {
            id: 'GM',
            displayValue: 'Gambia',
          },
          {
            id: 'KY',
            displayValue: 'Cayman Islands',
          },
          {
            id: 'PL',
            displayValue: 'Poland',
          },
          {
            id: 'ON',
            displayValue: 'Canada (Ontario)',
          },
          {
            id: 'KM',
            displayValue: 'Comoros',
          },
          {
            id: 'FI',
            displayValue: 'Finland',
          },
          {
            id: 'QC',
            displayValue: 'Canada (Quebec)',
          },
          {
            id: 'CZ',
            displayValue: 'Czech Republic',
          },
          {
            id: 'GF',
            displayValue: 'French Guiana',
          },
          {
            id: 'HR',
            displayValue: 'Croatia',
          },
          {
            id: 'PF',
            displayValue: 'French Polynesia',
          },
          {
            id: 'FQ',
            displayValue: 'French Southern and Antarctic Territories',
          },
          {
            id: 'EG',
            displayValue: 'Egypt',
          },
          {
            id: 'FO',
            displayValue: 'Faroe Islands',
          },
          {
            id: 'EE',
            displayValue: 'Estonia',
          },
          {
            id: 'CD',
            displayValue: 'Congo - Kinshasa',
          },
          {
            id: 'CS',
            displayValue: 'Canada (Saskatchewan)',
          },
          {
            id: 'NT',
            displayValue: 'Canada (Northwest Territories)',
          },
          {
            id: 'CC',
            displayValue: 'Cocos [Keeling] Islands',
          },
          {
            id: 'CT',
            displayValue: 'Canton and Enderbury Islands',
          },
          {
            id: 'CG',
            displayValue: 'Congo - Brazzaville',
          },
          {
            id: 'CM',
            displayValue: 'Cameroon',
          },
          {
            id: 'CR',
            displayValue: 'Costa Rica',
          },
          {
            id: 'CI',
            displayValue: 'Côte d’Ivoire',
          },
          {
            id: 'CL',
            displayValue: 'Chile',
          },
          {
            id: 'CV',
            displayValue: 'Cape Verde',
          },
          {
            id: 'DE',
            displayValue: 'Germany',
          },
          {
            id: 'CK',
            displayValue: 'Cook Islands',
          },
          {
            id: 'ET',
            displayValue: 'Ethiopia',
          },
          {
            id: 'FJ',
            displayValue: 'Fiji',
          },
          {
            id: 'GA',
            displayValue: 'Gabon',
          },
          {
            id: 'GE',
            displayValue: 'Georgia',
          },
          {
            id: 'PY',
            displayValue: 'Paraguay',
          },
          {
            id: 'PT',
            displayValue: 'Portugal',
          },
          {
            id: 'PH',
            displayValue: 'Philippines',
          },
          {
            id: 'QA',
            displayValue: 'Qatar',
          },
          {
            id: 'PK',
            displayValue: 'Pakistan',
          },
          {
            id: 'PR',
            displayValue: 'Puerto Rico',
          },
          {
            id: 'PN',
            displayValue: 'Pitcairn Islands',
          },
          {
            id: 'PW',
            displayValue: 'Palau',
          },
          {
            id: 'PS',
            displayValue: 'Palestinian Territories',
          },
          {
            id: 'RE',
            displayValue: 'Réunion',
          },
          {
            id: 'RU',
            displayValue: 'Russia',
          },
          {
            id: 'RW',
            displayValue: 'Rwanda',
          },
          {
            id: 'SC',
            displayValue: 'Seychelles',
          },
          {
            id: 'RO',
            displayValue: 'Romania',
          },
          {
            id: 'SD',
            displayValue: 'Sudan',
          },
          {
            id: 'SH',
            displayValue: 'Saint Helena',
          },
          {
            id: 'SE',
            displayValue: 'Sweden',
          },
          {
            id: 'SG',
            displayValue: 'Singapore',
          },
          {
            id: 'ER',
            displayValue: 'Eritrea',
          },
          {
            id: 'CA',
            displayValue: 'Canada',
          },
          {
            id: 'CF',
            displayValue: 'Central African Republic',
          },
          {
            id: 'YE',
            displayValue: 'Yemen',
          },
          {
            id: 'YT',
            displayValue: 'Mayotte',
          },
          {
            id: 'TJ',
            displayValue: 'Tajikistan',
          },
          {
            id: 'TK',
            displayValue: 'Tokelau',
          },
          {
            id: 'ZA',
            displayValue: 'South Africa',
          },
          {
            id: 'TL',
            displayValue: 'Timor-Leste',
          },
          {
            id: 'TM',
            displayValue: 'Turkmenistan',
          },
          {
            id: 'TN',
            displayValue: 'Tunisia',
          },
          {
            id: 'TR',
            displayValue: 'Turkey',
          },
          {
            id: 'TT',
            displayValue: 'Trinidad and Tobago',
          },
          {
            id: 'FX',
            displayValue: 'Metropolitan France',
          },
          {
            id: 'TV',
            displayValue: 'Tuvalu',
          },
          {
            id: 'ZM',
            displayValue: 'Zambia',
          },
          {
            id: 'ZW',
            displayValue: 'Zimbabwe',
          },
          {
            id: 'TW',
            displayValue: 'Taiwan',
          },
          {
            id: 'TZ',
            displayValue: 'Tanzania',
          },
          {
            id: 'UA',
            displayValue: 'Ukraine',
          },
          {
            id: 'UG',
            displayValue: 'Uganda',
          },
          {
            id: 'UM',
            displayValue: 'U.S. Minor Outlying Islands',
          },
          {
            id: 'US',
            displayValue: 'United States',
          },
          {
            id: 'UY',
            displayValue: 'Uruguay',
          },
          {
            id: 'UZ',
            displayValue: 'Uzbekistan',
          },
          {
            id: 'VA',
            displayValue: 'Vatican City',
          },
          {
            id: 'VC',
            displayValue: 'Saint Vincent and the Grenadines',
          },
          {
            id: 'VE',
            displayValue: 'Venezuela',
          },
          {
            id: 'VI',
            displayValue: 'U.S. Virgin Islands',
          },
          {
            id: 'LY',
            displayValue: 'Libya',
          },
          {
            id: 'NL',
            displayValue: 'Netherlands',
          },
          {
            id: 'SI',
            displayValue: 'Slovenia',
          },
          {
            id: 'SJ',
            displayValue: 'Svalbard and Jan Mayen',
          },
          {
            id: 'SK',
            displayValue: 'Slovakia',
          },
          {
            id: 'SL',
            displayValue: 'Sierra Leone',
          },
          {
            id: 'SM',
            displayValue: 'San Marino',
          },
          {
            id: 'SN',
            displayValue: 'Senegal',
          },
          {
            id: 'SO',
            displayValue: 'Somalia',
          },
          {
            id: 'SR',
            displayValue: 'Suriname',
          },
          {
            id: 'ST',
            displayValue: 'São Tomé and Príncipe',
          },
          {
            id: 'SV',
            displayValue: 'El Salvador',
          },
          {
            id: 'SY',
            displayValue: 'Syria',
          },
          {
            id: 'SZ',
            displayValue: 'Swaziland',
          },
          {
            id: 'TC',
            displayValue: 'Turks and Caicos Islands',
          },
          {
            id: 'TD',
            displayValue: 'Chad',
          },
          {
            id: 'TF',
            displayValue: 'French Southern Territories',
          },
          {
            id: 'TG',
            displayValue: 'Togo',
          },
          {
            id: 'TH',
            displayValue: 'Thailand',
          },
          {
            id: 'VN',
            displayValue: 'Vietnam',
          },
          {
            id: 'VU',
            displayValue: 'Vanuatu',
          },
          {
            id: 'WF',
            displayValue: 'Wallis and Futuna',
          },
          {
            id: 'WS',
            displayValue: 'Samoa',
          },
          {
            id: 'JT',
            displayValue: 'Johnston Island',
          },
          {
            id: 'AQ',
            displayValue: 'Antarctica',
          },
          {
            id: 'AU',
            displayValue: 'Australia',
          },
          {
            id: 'AW',
            displayValue: 'Aruba',
          },
          {
            id: 'AZ',
            displayValue: 'Azerbaijan',
          },
          {
            id: 'BA',
            displayValue: 'Bosnia and Herzegovina',
          },
          {
            id: 'BB',
            displayValue: 'Barbados',
          },
          {
            id: 'BD',
            displayValue: 'Bangladesh',
          },
          {
            id: 'BE',
            displayValue: 'Belgium',
          },
          {
            id: 'BG',
            displayValue: 'Bulgaria',
          },
          {
            id: 'BH',
            displayValue: 'Bahrain',
          },
          {
            id: 'BJ',
            displayValue: 'Benin',
          },
          {
            id: 'BM',
            displayValue: 'Bermuda',
          },
          {
            id: 'BN',
            displayValue: 'Brunei',
          },
          {
            id: 'BO',
            displayValue: 'Bolivia',
          },
          {
            id: 'BQ',
            displayValue: 'British Antarctic Territory',
          },
          {
            id: 'BR',
            displayValue: 'Brazil',
          },
          {
            id: 'BS',
            displayValue: 'Bahamas',
          },
          {
            id: 'BT',
            displayValue: 'Bhutan',
          },
          {
            id: 'BV',
            displayValue: 'Bouvet Island',
          },
          {
            id: 'BW',
            displayValue: 'Botswana',
          },
          {
            id: 'BY',
            displayValue: 'Belarus',
          },
          {
            id: 'BZ',
            displayValue: 'Belize',
          },
          {
            id: 'DZ',
            displayValue: 'Algeria',
          },
          {
            id: 'IO',
            displayValue: 'British Indian Ocean Territory',
          },
          {
            id: 'VG',
            displayValue: 'British Virgin Islands',
          },
          {
            id: 'GG',
            displayValue: 'Guernsey',
          },
          {
            id: 'BI',
            displayValue: 'Burundi',
          },
          {
            id: 'GD',
            displayValue: 'Grenada',
          },
          {
            id: 'GL',
            displayValue: 'Greenland',
          },
          {
            id: 'GN',
            displayValue: 'Guinea',
          },
          {
            id: 'GP',
            displayValue: 'Guadeloupe',
          },
          {
            id: 'GR',
            displayValue: 'Greece',
          },
          {
            id: 'GT',
            displayValue: 'Guatemala',
          },
          {
            id: 'GU',
            displayValue: 'Guam',
          },
          {
            id: 'GW',
            displayValue: 'Guinea-Bissau',
          },
          {
            id: 'GY',
            displayValue: 'Guyana',
          },
          {
            id: 'HM',
            displayValue: 'Heard Island and McDonald Islands',
          },
          {
            id: 'HN',
            displayValue: 'Honduras',
          },
          {
            id: 'HT',
            displayValue: 'Haiti',
          },
          {
            id: 'HU',
            displayValue: 'Hungary',
          },
          {
            id: 'ID',
            displayValue: 'Indonesia',
          },
          {
            id: 'IE',
            displayValue: 'Ireland',
          },
          {
            id: 'IL',
            displayValue: 'Israel',
          },
          {
            id: 'IM',
            displayValue: 'Isle of Man',
          },
          {
            id: 'IN',
            displayValue: 'India',
          },
          {
            id: 'IQ',
            displayValue: 'Iraq',
          },
          {
            id: 'IR',
            displayValue: 'Iran',
          },
          {
            id: 'IS',
            displayValue: 'Iceland',
          },
          {
            id: 'IT',
            displayValue: 'Italy',
          },
          {
            id: 'KH',
            displayValue: 'Cambodia',
          },
          {
            id: 'LS',
            displayValue: 'Lesotho',
          },
          {
            id: 'LT',
            displayValue: 'Lithuania',
          },
          {
            id: 'LU',
            displayValue: 'Luxembourg',
          },
          {
            id: 'MP',
            displayValue: 'Northern Mariana Islands',
          },
          {
            id: 'MQ',
            displayValue: 'Martinique',
          },
          {
            id: 'NG',
            displayValue: 'Nigeria',
          },
          {
            id: 'MI',
            displayValue: 'Midway Islands',
          },
          {
            id: 'MR',
            displayValue: 'Mauritania',
          },
          {
            id: 'MS',
            displayValue: 'Montserrat',
          },
          {
            id: 'NI',
            displayValue: 'Nicaragua',
          },
          {
            id: 'MA',
            displayValue: 'Morocco',
          },
          {
            id: 'MT',
            displayValue: 'Malta',
          },
          {
            id: 'MU',
            displayValue: 'Mauritius',
          },
          {
            id: 'AN',
            displayValue: 'Netherlands Antilles',
          },
          {
            id: 'JM',
            displayValue: 'Jamaica',
          },
          {
            id: 'NO',
            displayValue: 'Norway',
          },
          {
            id: 'MV',
            displayValue: 'Maldives',
          },
          {
            id: 'NP',
            displayValue: 'Nepal',
          },
          {
            id: 'MC',
            displayValue: 'Monaco',
          },
          {
            id: 'MW',
            displayValue: 'Malawi',
          },
          {
            id: 'NR',
            displayValue: 'Nauru',
          },
          {
            id: 'NU',
            displayValue: 'Niue',
          },
          {
            id: 'MD',
            displayValue: 'Moldova',
          },
          {
            id: 'JO',
            displayValue: 'Jordan',
          },
          {
            id: 'NZ',
            displayValue: 'New Zealand',
          },
          {
            id: 'ME',
            displayValue: 'Montenegro',
          },
          {
            id: 'MF',
            displayValue: 'Saint Martin',
          },
          {
            id: 'OM',
            displayValue: 'Oman',
          },
          {
            id: 'MG',
            displayValue: 'Madagascar',
          },
          {
            id: 'MX',
            displayValue: 'Mexico',
          },
          {
            id: 'MZ',
            displayValue: 'Mozambique',
          },
          {
            id: 'PC',
            displayValue: 'Pacific Islands Trust Territory',
          },
          {
            id: 'PA',
            displayValue: 'Panama',
          },
          {
            id: 'MH',
            displayValue: 'Marshall Islands',
          },
          {
            id: 'MK',
            displayValue: 'Macedonia',
          },
          {
            id: 'NA',
            displayValue: 'Namibia',
          },
          {
            id: 'NC',
            displayValue: 'New Caledonia',
          },
          {
            id: 'NE',
            displayValue: 'Niger',
          },
          {
            id: 'FM',
            displayValue: 'Micronesia',
          },
          {
            id: 'JE',
            displayValue: 'Jersey',
          },
          {
            id: 'ML',
            displayValue: 'Mali',
          },
          {
            id: 'JP',
            displayValue: 'Japan',
          },
          {
            id: 'MM',
            displayValue: 'Myanmar [Burma]',
          },
          {
            id: 'MN',
            displayValue: 'Mongolia',
          },
          {
            id: 'MO',
            displayValue: 'Macau SAR China',
          },
          {
            id: 'PE',
            displayValue: 'Peru',
          },
          {
            id: 'NF',
            displayValue: 'Norfolk Island',
          },
          {
            id: 'YD',
            displayValue: "People's Democratic Republic of Yemen",
          },
          {
            id: 'KE',
            displayValue: 'Kenya',
          },
          {
            id: 'KG',
            displayValue: 'Kyrgyzstan',
          },
          {
            id: 'KI',
            displayValue: 'Kiribati',
          },
          {
            id: 'KN',
            displayValue: 'Saint Kitts and Nevis',
          },
          {
            id: 'KP',
            displayValue: 'North Korea',
          },
          {
            id: 'KW',
            displayValue: 'Kuwait',
          },
          {
            id: 'KZ',
            displayValue: 'Kazakhstan',
          },
          {
            id: 'LA',
            displayValue: 'Laos',
          },
          {
            id: 'LB',
            displayValue: 'Lebanon',
          },
          {
            id: 'LC',
            displayValue: 'Saint Lucia',
          },
          {
            id: 'LI',
            displayValue: 'Liechtenstein',
          },
          {
            id: 'LR',
            displayValue: 'Liberia',
          },
          {
            id: 'KR',
            displayValue: 'South Korea',
          },
          {
            id: 'LK',
            displayValue: 'Sri Lanka',
          },
          {
            id: 'LV',
            displayValue: 'Latvia',
          },
          {
            id: 'MY',
            displayValue: 'Malaysia',
          },
          {
            id: 'PU',
            displayValue: 'U.S. Miscellaneous Pacific Islands',
          },
          {
            id: 'PM',
            displayValue: 'Saint Pierre and Miquelon',
          },
          {
            id: 'RS',
            displayValue: 'Serbia',
          },
          {
            id: 'ZZ',
            displayValue: 'Unknown or Invalid Region',
          },
          {
            id: 'WK',
            displayValue: 'Wake Island',
          },
          {
            id: 'SA',
            displayValue: 'Saudi Arabia',
          },
          {
            id: 'SB',
            displayValue: 'Solomon Islands',
          },
          {
            id: 'AD',
            displayValue: 'Andorra',
          },
          {
            id: 'AE',
            displayValue: 'United Arab Emirates',
          },
          {
            id: 'AF',
            displayValue: 'Afghanistan',
          },
          {
            id: 'AG',
            displayValue: 'Antigua and Barbuda',
          },
          {
            id: 'AI',
            displayValue: 'Anguilla',
          },
          {
            id: 'AL',
            displayValue: 'Albania',
          },
          {
            id: 'AM',
            displayValue: 'Armenia',
          },
          {
            id: 'AO',
            displayValue: 'Angola',
          },
          {
            id: 'AR',
            displayValue: 'Argentina',
          },
          {
            id: 'AS',
            displayValue: 'American Samoa',
          },
          {
            id: 'AT',
            displayValue: 'Austria',
          },
          {
            id: 'AX',
            displayValue: 'Åland Islands',
          },
          {
            id: 'BF',
            displayValue: 'Burkina Faso',
          },
          {
            id: 'BL',
            displayValue: 'Saint Barthélemy',
          },
          {
            id: 'NB',
            displayValue: 'Canada (New Brunswick)',
          },
          {
            id: 'CH',
            displayValue: 'Switzerland',
          },
          {
            id: 'ES',
            displayValue: 'Spain',
          },
          {
            id: 'GB',
            displayValue: 'United Kingdom',
          },
          {
            id: 'GC',
            displayValue: 'Channel Islands',
          },
          {
            id: 'GS',
            displayValue: 'South Georgia and the South Sandwich Islands',
          },
          {
            id: 'HK',
            displayValue: 'Hong Kong SAR China',
          },
          {
            id: 'TO',
            displayValue: 'Tonga',
          },
        ],
      },
      {
        optionType: '= country_code',
        display: 'Set it to the filing country',
        requires: [],
      },
      {
        display: 'Not provided',
        optionType: 'not_provided',
      },
    ],
    value: 'static',
    optionalValue: 'CN',
    disabled: false,
    selected: false,
    index: null,
  },
  {
    id: 'ec_vat_number',
    display: 'EC Vat Number',
    description: 'VAT number of the supplier or customer.',
    type: 'text',
    required: false,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
      {
        display: 'Not provided',
        optionType: 'not_provided',
      },
    ],
    value: 'column',
    optionalValue: '',
    disabled: false,
    selected: false,
    index: null,
  },
  {
    id: 'ccy',
    display: 'Currency',
    description: 'ISO currency code of the transaction as per the original invoice.',
    type: 'text',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
      {
        display: 'Custom value',
        optionType: 'static',
        options: [
          {
            id: 'DJF',
            displayValue: 'Djibouti Franc',
          },
          {
            id: 'LBP',
            displayValue: 'Lebanese Pound',
          },
          {
            id: 'FJD',
            displayValue: 'Fiji Dollar',
          },
          {
            id: 'BBD',
            displayValue: 'Barbados Dollar',
          },
          {
            id: 'GHS',
            displayValue: 'Ghana Cedi',
          },
          {
            id: 'KGS',
            displayValue: 'Som',
          },
          {
            id: 'KHR',
            displayValue: 'Riel',
          },
          {
            id: 'HKD',
            displayValue: 'Hong Kong Dollar',
          },
          {
            id: 'CNY',
            displayValue: 'Yuan Renminbi',
          },
          {
            id: 'LAK',
            displayValue: 'Lao Kip',
          },
          {
            id: 'BND',
            displayValue: 'Brunei Dollar',
          },
          {
            id: 'BOB',
            displayValue: 'Boliviano',
          },
          {
            id: 'GMD',
            displayValue: 'Dalasi',
          },
          {
            id: 'BRL',
            displayValue: 'Brazilian Real',
          },
          {
            id: 'GTQ',
            displayValue: 'Quetzal',
          },
          {
            id: 'BSD',
            displayValue: 'Bahamian Dollar',
          },
          {
            id: 'MRO',
            displayValue: 'Ouguiya',
          },
          {
            id: 'INR',
            displayValue: 'Indian Rupee',
          },
          {
            id: 'SYP',
            displayValue: 'Syrian Pound',
          },
          {
            id: 'TND',
            displayValue: 'Tunisian Dinar',
          },
          {
            id: 'DOP',
            displayValue: 'Dominican Peso',
          },
          {
            id: 'BZD',
            displayValue: 'Belize Dollar',
          },
          {
            id: 'CAD',
            displayValue: 'Canadian Dollar',
          },
          {
            id: 'MGA',
            displayValue: 'Malagasy Ariary',
          },
          {
            id: 'OMR',
            displayValue: 'Rial Omani',
          },
          {
            id: 'CDF',
            displayValue: 'Congolese Franc',
          },
          {
            id: 'ERN',
            displayValue: 'Nakfa',
          },
          {
            id: 'MKD',
            displayValue: 'Denar',
          },
          {
            id: 'MMK',
            displayValue: 'Kyat',
          },
          {
            id: 'DZD',
            displayValue: 'Algerian Dinar',
          },
          {
            id: 'MWK',
            displayValue: 'Malawi Kwacha',
          },
          {
            id: 'PAB',
            displayValue: 'Balboa',
          },
          {
            id: 'IRR',
            displayValue: 'Iranian Rial',
          },
          {
            id: 'MNT',
            displayValue: 'Tugrik',
          },
          {
            id: 'GBP',
            displayValue: 'Pound Sterling',
          },
          {
            id: 'MZN',
            displayValue: 'Mozambique Metical',
          },
          {
            id: 'PGK',
            displayValue: 'Kina',
          },
          {
            id: 'EGP',
            displayValue: 'Egyptian Pound',
          },
          {
            id: 'HTG',
            displayValue: 'Gourde',
          },
          {
            id: 'XPF',
            displayValue: 'CFP Franc',
          },
          {
            id: 'FKP',
            displayValue: 'Falkland Islands Pound',
          },
          {
            id: 'ISK',
            displayValue: 'Iceland Krona',
          },
          {
            id: 'JMD',
            displayValue: 'Jamaican Dollar',
          },
          {
            id: 'JPY',
            displayValue: 'Yen',
          },
          {
            id: 'HUF',
            displayValue: 'Forint',
          },
          {
            id: 'GEL',
            displayValue: 'Lari',
          },
          {
            id: 'MVR',
            displayValue: 'Rufiyaa',
          },
          {
            id: 'NPR',
            displayValue: 'Nepalese Rupee',
          },
          {
            id: 'IDR',
            displayValue: 'Rupiah',
          },
          {
            id: 'MYR',
            displayValue: 'Malaysian Ringgit',
          },
          {
            id: 'MDL',
            displayValue: 'Moldovan Leu',
          },
          {
            id: 'ILS',
            displayValue: 'New Israeli Sheqel',
          },
          {
            id: 'NAD',
            displayValue: 'Namibia Dollar',
          },
          {
            id: 'PHP',
            displayValue: 'Philippine Piso',
          },
          {
            id: 'PKR',
            displayValue: 'Pakistan Rupee',
          },
          {
            id: 'CHF',
            displayValue: 'Swiss Franc',
          },
          {
            id: 'PLN',
            displayValue: 'Zloty',
          },
          {
            id: 'NIO',
            displayValue: 'Cordoba Oro',
          },
          {
            id: 'NOK',
            displayValue: 'Norwegian Krone',
          },
          {
            id: 'XAF',
            displayValue: 'CFA Franc BEAC',
          },
          {
            id: 'TOP',
            displayValue: "Pa'anga",
          },
          {
            id: 'GIP',
            displayValue: 'Gibraltar Pound',
          },
          {
            id: 'KES',
            displayValue: 'Kenyan Shilling',
          },
          {
            id: 'SGD',
            displayValue: 'Singapore Dollar',
          },
          {
            id: 'UYU',
            displayValue: 'Peso Uruguayo',
          },
          {
            id: 'MOP',
            displayValue: 'Pataca',
          },
          {
            id: 'TJS',
            displayValue: 'Somoni',
          },
          {
            id: 'THB',
            displayValue: 'Baht',
          },
          {
            id: 'MXN',
            displayValue: 'Mexican Peso',
          },
          {
            id: 'SOS',
            displayValue: 'Somali Shilling',
          },
          {
            id: 'STD',
            displayValue: 'Dobra',
          },
          {
            id: 'IQD',
            displayValue: 'Iraqi Dinar',
          },
          {
            id: 'BMD',
            displayValue: 'Bermudian Dollar',
          },
          {
            id: 'USD',
            displayValue: 'US Dollar',
          },
          {
            id: 'AZN',
            displayValue: 'Azerbaijan Manat',
          },
          {
            id: 'RSD',
            displayValue: 'Serbian Dinar',
          },
          {
            id: 'AUD',
            displayValue: 'Australian Dollar',
          },
          {
            id: 'TZS',
            displayValue: 'Tanzanian Shilling',
          },
          {
            id: 'AMD',
            displayValue: 'Armenian Dram',
          },
          {
            id: 'TMT',
            displayValue: 'Turkmenistan New Manat',
          },
          {
            id: 'SLL',
            displayValue: 'Leone',
          },
          {
            id: 'BHD',
            displayValue: 'Bahraini Dinar',
          },
          {
            id: 'SDG',
            displayValue: 'Sudanese Pound',
          },
          {
            id: 'LRD',
            displayValue: 'Liberian Dollar',
          },
          {
            id: 'AWG',
            displayValue: 'Aruban Florin',
          },
          {
            id: 'VND',
            displayValue: 'Dong',
          },
          {
            id: 'NGN',
            displayValue: 'Naira',
          },
          {
            id: 'PYG',
            displayValue: 'Guarani',
          },
          {
            id: 'VUV',
            displayValue: 'Vatu',
          },
          {
            id: 'VEF',
            displayValue: 'Bolivar',
          },
          {
            id: 'ZMW',
            displayValue: 'Zambian Kwacha',
          },
          {
            id: 'DKK',
            displayValue: 'Danish Krone',
          },
          {
            id: 'KWD',
            displayValue: 'Kuwaiti Dinar',
          },
          {
            id: 'BGN',
            displayValue: 'Bulgarian Lev',
          },
          {
            id: 'QAR',
            displayValue: 'Qatari Rial',
          },
          {
            id: 'RUB',
            displayValue: 'Russian Ruble',
          },
          {
            id: 'RWF',
            displayValue: 'Rwanda Franc',
          },
          {
            id: 'KPW',
            displayValue: 'North Korean Won',
          },
          {
            id: 'BAM',
            displayValue: 'Convertible Mark',
          },
          {
            id: 'SAR',
            displayValue: 'Saudi Riyal',
          },
          {
            id: 'NZD',
            displayValue: 'New Zealand Dollar',
          },
          {
            id: 'CLP',
            displayValue: 'Chilean Peso',
          },
          {
            id: 'LYD',
            displayValue: 'Libyan Dinar',
          },
          {
            id: 'HNL',
            displayValue: 'Lempira',
          },
          {
            id: 'KRW',
            displayValue: 'Won',
          },
          {
            id: 'CVE',
            displayValue: 'Cabo Verde Escudo',
          },
          {
            id: 'COP',
            displayValue: 'Colombian Peso',
          },
          {
            id: 'CRC',
            displayValue: 'Costa Rican Colon',
          },
          {
            id: 'KYD',
            displayValue: 'Cayman Islands Dollar',
          },
          {
            id: 'KZT',
            displayValue: 'Tenge',
          },
          {
            id: 'LKR',
            displayValue: 'Sri Lanka Rupee',
          },
          {
            id: 'KMF',
            displayValue: 'Comorian Franc ',
          },
          {
            id: 'GYD',
            displayValue: 'Guyana Dollar',
          },
          {
            id: 'ANG',
            displayValue: 'Netherlands Antillean Guilder',
          },
          {
            id: 'CZK',
            displayValue: 'Czech Koruna',
          },
          {
            id: 'GNF',
            displayValue: 'Guinean Franc',
          },
          {
            id: 'LSL',
            displayValue: 'Loti',
          },
          {
            id: 'BWP',
            displayValue: 'Pula',
          },
          {
            id: 'TWD',
            displayValue: 'New Taiwan Dollar',
          },
          {
            id: 'BYN',
            displayValue: 'Belarusian Ruble',
          },
          {
            id: 'TRY',
            displayValue: 'Turkish Lira',
          },
          {
            id: 'ZAR',
            displayValue: 'Rand',
          },
          {
            id: 'ALL',
            displayValue: 'Lek',
          },
          {
            id: 'SSP',
            displayValue: 'South Sudanese Pound',
          },
          {
            id: 'ETB',
            displayValue: 'Ethiopian Birr',
          },
          {
            id: 'SBD',
            displayValue: 'Solomon Islands Dollar',
          },
          {
            id: 'SRD',
            displayValue: 'Surinam Dollar',
          },
          {
            id: 'MUR',
            displayValue: 'Mauritius Rupee',
          },
          {
            id: 'BDT',
            displayValue: 'Taka',
          },
          {
            id: 'AFN',
            displayValue: 'Afghani',
          },
          {
            id: 'HRK',
            displayValue: 'Kuna',
          },
          {
            id: 'UZS',
            displayValue: 'Uzbekistan Sum',
          },
          {
            id: 'ARS',
            displayValue: 'Argentine Peso',
          },
          {
            id: 'SZL',
            displayValue: 'Lilangeni',
          },
          {
            id: 'XOF',
            displayValue: 'CFA Franc BCEAO',
          },
          {
            id: 'BIF',
            displayValue: 'Burundi Franc',
          },
          {
            id: 'UGX',
            displayValue: 'Uganda Shilling',
          },
          {
            id: 'XCD',
            displayValue: 'East Caribbean Dollar',
          },
          {
            id: 'AED',
            displayValue: 'UAE Dirham',
          },
          {
            id: 'EUR',
            displayValue: 'Euro',
          },
          {
            id: 'RON',
            displayValue: 'Romanian Leu',
          },
          {
            id: 'MAD',
            displayValue: 'Moroccan Dirham',
          },
          {
            id: 'TTD',
            displayValue: 'Trinidad and Tobago Dollar',
          },
          {
            id: 'PEN',
            displayValue: 'Sol',
          },
          {
            id: 'SEK',
            displayValue: 'Swedish Krona',
          },
          {
            id: 'JOD',
            displayValue: 'Jordanian Dinar',
          },
          {
            id: 'YER',
            displayValue: 'Yemeni Rial',
          },
          {
            id: 'AOA',
            displayValue: 'Kwanza',
          },
          {
            id: 'UAH',
            displayValue: 'Hryvnia',
          },
          {
            id: 'SHP',
            displayValue: 'Saint Helena Pound',
          },
          {
            id: 'SCR',
            displayValue: 'Seychelles Rupee',
          },
          {
            id: 'CUP',
            displayValue: 'Cuban Peso',
          },
        ],
      },
    ],
    value: 'column',
    optionalValue: '',
    disabled: false,
    selected: false,
    index: null,
  },
  {
    id: 'net',
    display: 'Net',
    description: 'Net amount per transaction.',
    type: 'currency',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
      {
        optionType: '= gross - vat',
        display: 'Calculate it from Gross - VAT',
        requires: ['gross', 'vat'],
      },
    ],
    value: 'column',
    optionalValue: '',
    disabled: false,
    selected: false,
    index: null,
  },
  {
    id: 'vat',
    display: 'VAT',
    description: 'VAT amount per transaction.',
    type: 'currency',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
    ],
    value: 'column',
    optionalValue: '',
    disabled: false,
    selected: false,
    index: null,
  },
  {
    id: 'gross',
    display: 'Gross',
    description: 'Gross amount per transaction.',
    type: 'currency',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
      {
        optionType: '= net + vat',
        display: 'Calculate it from Net + VAT',
        requires: ['net', 'vat'],
      },
    ],
    value: 'column',
    optionalValue: '',
    disabled: false,
    selected: false,
    index: null,
  },
  {
    id: 'client_transaction_type',
    display: 'Client Transaction Type',
    description: 'Either a tax code, or transaction type per the ERP system.',
    type: 'text',
    required: true,
    options: [
      {
        display: 'In my sheet',
        optionType: 'column',
      },
    ],
    value: 'column',
    optionalValue: '',
    disabled: false,
    selected: false,
    index: null,
  },
];

export const mapping = {
  id: 'c062eb55-419e-47f2-9ab0-bebc2d2324d3',
  name: 'test new edit',
  vat_number: '3e7f1d70-fbcc-441c-a2cb-617054430bcc',
  filing_type: 'dd67a25b-170a-4164-b6a7-1460e104750a',
  header_start: 1,
  row_start: 2,
  column_map: {
    ccy: {
      type: 'column',
      value: '6',
    },
    net: {
      type: 'column',
      value: '4',
    },
    vat: {
      type: 'column',
      value: '7',
    },
    gross: {
      type: 'column',
      value: '8',
    },
    invoice_date: {
      type: 'column',
      value: '0',
    },
    partner_name: {
      type: 'column',
      value: '3',
    },
    ec_vat_number: {
      type: 'column',
      value: '5',
    },
    invoice_number: {
      type: 'column',
      value: '1',
    },
    partner_country: {
      type: 'column',
      value: '2',
    },
    client_transaction_type: {
      type: 'column',
      value: '9',
    },
  },
};
